import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

interface OtpLoadingProps {
  className?: string;
}

export const OtpLoading = ({ className }: OtpLoadingProps) => (
  <div
    className={classNames(
      "flex flex-col items-center justify-center",
      className,
    )}
  >
    <Loader className="!p-0 mb-2" />
    <Typography.BodySm>{t("otp_challenge_modal.loading")}</Typography.BodySm>
  </div>
);

OtpLoading.displayName = "OtpLoading";
